/* Martin wishlist — localStorage-backed, no auth required.
   Storage shape: localStorage.martin_wishlist = JSON array of product handles. */
(function () {
  var KEY = 'martin_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) { return []; }
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) { return []; }
  }

  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) { /* quota */ }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!handle) { return false; }
    var arr = read();
    var idx = arr.indexOf(handle);
    if (idx === -1) {
      arr.unshift(handle);
      if (arr.length > 100) { arr.length = 100; }
    } else {
      arr.splice(idx, 1);
    }
    write(arr);
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { handles: arr.slice() } }));
    return arr.indexOf(handle) !== -1;
  }

  function syncButtons() {
    var set = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var h = btn.getAttribute('data-product-handle');
      var on = set.indexOf(h) !== -1;
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remover dos favoritos' : 'Salvar nos favoritos');
    });
    var counts = document.querySelectorAll('[data-wishlist-count]');
    counts.forEach(function (el) { el.textContent = set.length; });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-wishlist-toggle]');
    if (!btn) { return; }
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    var nowOn = toggle(handle);
    btn.classList.toggle('is-saved', nowOn);
    btn.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: nowOn ? 'wishlist_add' : 'wishlist_remove',
        item_handle: handle
      });
    } catch (e) { /* noop */ }
  });

  document.addEventListener('wishlist:changed', syncButtons);
  document.addEventListener('DOMContentLoaded', syncButtons);
  if (document.readyState !== 'loading') { syncButtons(); }

  /* Hydrate /pages/wishlist if present. */
  function hydrateWishlistPage() {
    var container = document.querySelector('[data-wishlist-grid]');
    if (!container) { return; }
    var handles = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (handles.length === 0) {
      if (empty) { empty.hidden = false; }
      container.hidden = true;
      return;
    }
    if (empty) { empty.hidden = true; }
    container.hidden = false;
    container.innerHTML = '<p class="wishlist-loading">Carregando…</p>';

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image ? ('<img src="' + p.featured_image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">') : '';
        var price = (p.price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        return '<li class="wishlist-grid__item" data-product-handle="' + escapeHtml(p.handle) + '">' +
          '<a class="wishlist-grid__link" href="' + escapeHtml(p.url) + '">' +
            '<div class="wishlist-grid__media">' + img + '</div>' +
            '<div class="wishlist-grid__body">' +
              '<span class="wishlist-grid__title">' + escapeHtml(p.title) + '</span>' +
              '<span class="wishlist-grid__price">' + price + '</span>' +
            '</div>' +
          '</a>' +
          '<button type="button" class="wishlist-grid__remove" data-wishlist-toggle data-product-handle="' + escapeHtml(p.handle) + '" aria-label="Remover dos favoritos">Remover</button>' +
        '</li>';
      }).join('');
      container.innerHTML = '<ul class="wishlist-grid__list">' + html + '</ul>';
    });
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  document.addEventListener('DOMContentLoaded', hydrateWishlistPage);
  document.addEventListener('wishlist:changed', hydrateWishlistPage);
  if (document.readyState !== 'loading') { hydrateWishlistPage(); }

  window.MartinWishlist = { read: read, has: has, toggle: toggle, sync: syncButtons };
})();
